import script from "./ProfileHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileHeader.vue?vue&type=script&setup=true&lang=js"

import "./ProfileHeader.vue?vue&type=style&index=0&id=2e694c78&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e694c78"]])

export default __exports__